import React from "react";
import { SvgIcon } from "@mui/material";
import ActivitySvg from "./icons/Activity.svg?react";
import AddProjectSvg from "./icons/AddProject.svg?react";
import MyAllEventSvg from "./icons/AllMyEvents.svg?react";
import BrainSvg from "./icons/Brain.svg?react";
import BuilderSvg from "./icons/Builders.svg?react";
import DashboardSvg from "./icons/Dashboard.svg?react";
import EventSvg from "./icons/Events.svg?react";
import GroupSvg from "./icons/Groups.svg?react";
import MemberSvg from "./icons/Members.svg?react";
import ProjectPageSvg from "./icons/ProjectsPage.svg?react";
import KudosSvg from "./icons/Kudos.svg?react";
import MiscSvg from "./icons/Misc.svg?react";
import RebelbaseLogoSvg from "./icons/Rebelbase_TextLogo.svg?react";

// HubLibrary
import HubLibrarySvg from "./icons/HubLibrary.svg?react";
// Hub Builders
import HubBuilderAnswerSvg from "./icons/HubBuilders/Answer.svg?react";
import HubBuilderInspirationByteSvg from "./icons/HubBuilders/InspirationByte.svg?react";
import HubBuilderIntroSvg from "./icons/HubBuilders/Intro.svg?react";
import HubBuilderSectionSvg from "./icons/HubBuilders/Section-1.svg?react";
import HubBuilderTopicSvg from "./icons/HubBuilders/Topic.svg?react";
import BuilderTopicSvg1 from "./icons/HubBuilders/BuilderTopic.svg?react";
import HubBuilderWorkshopSvg from "./icons/HubBuilders/Workshop.svg?react";

// Project Builders
import BuilderPublishedSvg from "./icons/ProjectBuilders/BuilderPublished.svg?react";
import BuilderUnPublishedSvg from "./icons/ProjectBuilders/BuilderUnPublished.svg?react";

import ProjectProfileEditSvg from "./icons/ProjectProfile/ProjectProfileEdit.svg?react";
import ProjectProfilePlaningSvg from "./icons/ProjectProfile/ProjectPlaning.svg?react";
import ProjectProfileIndustrySvg from "./icons/ProjectProfile/ProjectLocation.svg?react";

const ActivityIcon = (props) => (
  <SvgIcon component={ActivitySvg} inheritViewBox {...props} />
);
const AddProjectIcon = (props) => (
  <SvgIcon component={AddProjectSvg} inheritViewBox {...props} />
);
const MyAllEventIcon = (props) => (
  <SvgIcon component={MyAllEventSvg} inheritViewBox {...props} />
);
const BrainIcon = (props) => (
  <SvgIcon component={BrainSvg} inheritViewBox {...props} />
);
const BuilderIcon = (props) => (
  <SvgIcon component={BuilderSvg} inheritViewBox {...props} />
);
const DashboardIcon = (props) => (
  <SvgIcon component={DashboardSvg} inheritViewBox {...props} />
);
const EventIcon = (props) => (
  <SvgIcon component={EventSvg} inheritViewBox {...props} />
);
const GroupIcon = (props) => (
  <SvgIcon component={GroupSvg} inheritViewBox {...props} />
);
const MemberIcon = (props) => (
  <SvgIcon component={MemberSvg} inheritViewBox {...props} />
);
const ProjectPageIcon = (props) => (
  <SvgIcon component={ProjectPageSvg} inheritViewBox {...props} />
);
const KudosIcon = (props) => (
  <SvgIcon component={KudosSvg} inheritViewBox {...props} />
);
const MiscIcon = (props) => (
  <SvgIcon component={MiscSvg} inheritViewBox {...props} />
);
const RebelbaseLogoIcon = (props) => (
  <SvgIcon component={RebelbaseLogoSvg} inheritViewBox {...props} />
);

// HubLibrary
const HubLibraryIcon = (props) => (
  <SvgIcon component={HubLibrarySvg} inheritViewBox {...props} />
);

// Hub Builders
// TODO some icons are colored need to ask Nick to provide default gray color if possible
const HubBuilderAnswerIcon = (props) => (
  <SvgIcon component={HubBuilderAnswerSvg} inheritViewBox {...props} />
);
const HubBuilderInspirationByteIcon = (props) => (
  <SvgIcon component={HubBuilderInspirationByteSvg} inheritViewBox {...props} />
);
const HubBuilderIntroIcon = (props) => (
  <SvgIcon component={HubBuilderIntroSvg} inheritViewBox {...props} />
);
const HubBuilderSectionIcon = (props) => (
  <SvgIcon component={HubBuilderSectionSvg} inheritViewBox {...props} />
);
const HubBuilderTopicIcon = (props) => (
  <SvgIcon component={HubBuilderTopicSvg} inheritViewBox {...props} />
);
const HubBuilderWorkshopIcon = (props) => (
  <SvgIcon component={HubBuilderWorkshopSvg} inheritViewBox {...props} />
);
const HubBuilderTopicIcon1 = (props) => (
  <SvgIcon component={BuilderTopicSvg1} inheritViewBox {...props} />
);

// Project Builders
const BuilderPublishedIcon = (props) => (
  <SvgIcon component={BuilderPublishedSvg} inheritViewBox {...props} />
);
const BuilderUnPublishedIcon = (props) => (
  <SvgIcon component={BuilderUnPublishedSvg} inheritViewBox {...props} />
);

// Profile Profile Icons
const ProjectProfileEditIcon = (props) => (
  <SvgIcon component={ProjectProfileEditSvg} inheritViewBox {...props} />
);
const ProjectProfilePlaningIcon = (props) => (
  <SvgIcon component={ProjectProfilePlaningSvg} inheritViewBox {...props} />
);
const ProjectProfileIndustryIcon = (props) => (
  <SvgIcon component={ProjectProfileIndustrySvg} inheritViewBox {...props} />
);

export {
  ActivityIcon,
  AddProjectIcon,
  MyAllEventIcon,
  BrainIcon,
  BuilderIcon,
  DashboardIcon,
  EventIcon,
  GroupIcon,
  MemberIcon,
  ProjectPageIcon,
  KudosIcon,
  MiscIcon,
  RebelbaseLogoIcon,
  HubLibraryIcon,
  HubBuilderAnswerIcon,
  HubBuilderInspirationByteIcon,
  HubBuilderIntroIcon,
  HubBuilderSectionIcon,
  HubBuilderTopicIcon,
  HubBuilderTopicIcon1,
  HubBuilderWorkshopIcon,
  BuilderPublishedIcon,
  BuilderUnPublishedIcon,
  ProjectProfileEditIcon,
  ProjectProfilePlaningIcon,
  ProjectProfileIndustryIcon,
};
